/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of security events */
export enum SecurityEventType {
  AccountLockout,
  PasswordChange,
  PrivilegeEscalation,
  SuspiciousActivity,
  PolicyViolation,
  AccessDenied,
  DataBreach,
  SystemCompromise,
}

export type SecurityEventTypeArgs = SecurityEventType;

export function getSecurityEventTypeEncoder(): FixedSizeEncoder<SecurityEventTypeArgs> {
  return getEnumEncoder(SecurityEventType);
}

export function getSecurityEventTypeDecoder(): FixedSizeDecoder<SecurityEventType> {
  return getEnumDecoder(SecurityEventType);
}

export function getSecurityEventTypeCodec(): FixedSizeCodec<
  SecurityEventTypeArgs,
  SecurityEventType
> {
  return combineCodec(
    getSecurityEventTypeEncoder(),
    getSecurityEventTypeDecoder(),
  );
}
